import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/** Create a logical Media Library folder (section 8) — not a physical B2/Dropbox path. */
export function CreateFolderDialog({ open, onOpenChange, onCreate, projects, defaultProjectId }) {
  const [name, setName] = useState('');
  const [scope, setScope] = useState(defaultProjectId || 'all');

  const handleCreate = () => {
    if (!name.trim()) return;
    onCreate({ name: name.trim(), projectId: scope === 'all' ? null : scope });
    setName('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 sm:max-w-sm" data-testid="create-folder-dialog">
        <DialogHeader><DialogTitle className="text-white">Create Folder</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs text-[#8A93A6]">Folder name</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. B-Roll" className="h-8 text-sm bg-black/40 border-white/10 mt-1" data-testid="create-folder-name-input" onKeyDown={(e) => e.key === 'Enter' && handleCreate()} />
          </div>
          <div>
            <Label className="text-xs text-[#8A93A6]">Scope</Label>
            <Select value={scope} onValueChange={setScope}>
              <SelectTrigger className="h-8 text-sm bg-black/40 border-white/10 mt-1" data-testid="create-folder-scope-select"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#1C1F26] border-white/10">
                <SelectItem value="all">All Creator Media (any project)</SelectItem>
                {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="border-white/10" onClick={() => onOpenChange(false)} data-testid="create-folder-cancel-btn">Cancel</Button>
          <Button className="bg-[#3A7BFF] hover:bg-[#3A7BFF]/80" onClick={handleCreate} data-testid="create-folder-confirm-btn">Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
